module.exports = __webpack_public_path__ + "img/ONDA.662bfbfd.jpg";